import styled from "styled-components";
import { COLORS } from "../../styles/constants.style";

export const MuiPopupWrapper = styled.div`
  padding-left: 0px;

  .popper {
    z-index: 1;
  }
  .no-padding {
    display: block;
    padding: 0px;
  }
  .MuiPaper-rounded {
    border-radius: 8px;
    box-shadow: 0px 2px 12px 0px ${COLORS.shadow_black};
  }
`;
